import strings from 'utils/strings'
import {
  DASH_LABELS,
  DASH_TYPES,
  DIGITAL_DASH_CODE,
  DIGITAL_ICU_LEFT_FILE_NAME,
} from './dashConstants'

export const META_BY_LOCATION_DETAIL = {
  MST: {
    noTooltip: true,
    noFallback: true,
    openListView: true,
    noShowPartNumber: true,
  },
  MSF: {
    noTooltip: true,
    noFallback: true,
    openListView: true,
    noShowPartNumber: true,
  },
  ICU: {
    label: DASH_LABELS.A_PANEL_ICU,
    partOverride: '43N Panel-A ICU',
    noTooltip: true,
    disableEvents: true,
    partExpected: true,
    noShowPartNumber: true,
    [DIGITAL_DASH_CODE]: DIGITAL_ICU_LEFT_FILE_NAME,
  },
  ICUC5: {
    label: DASH_LABELS.A_PANEL_ICU,
    partOverride: DIGITAL_ICU_LEFT_FILE_NAME,
    noTooltip: true,
    disableEvents: true,
    partExpected: true,
    noShowPartNumber: true,
  },
  AUDSP: {
    partOverride: 'Head Unit',
    label: DASH_LABELS.RIGHT_HAND_B_PANEL_AUX,
    noTooltip: true,
    disableEvents: false,
    openListView: true,
    noShowPartNumber: true,
  },
  DSP: {
    partOverride: 'Head Unit',
    noTooltip: true,
  },
  AUADP: {
    label: DASH_LABELS.RIGHT_HAND_B_PANEL_AUX,
  },
  AUPNL: {
    partOverride: '22-75780-000',
    label: DASH_LABELS.RIGHT_HAND_B_PANEL_AUX,
    noTooltip: true,
    disableEvents: false,
    openListView: true,
    noShowPartNumber: true,
    containedIn: 'AGFAC',
  },
  AGFAC: {
    label: DASH_LABELS.RIGHT_HAND_B_PANEL_AG,
    partOverride: 'A22-75939-001',
    noTooltip: true,
    disableEvents: false,
    openListView: true,
    noShowPartNumber: true,
  },
}

export const DASH_META = {
  name: DASH_TYPES.DASH_43N_E_VAULT,
  panels: ['ICU', 'AGFAC'],
  navPanels: ['AUPNL'],
  navOrder: ['ICU', 'AUPNL', 'AGFAC'],
  // PBI 479416: keep the full-width AGFAC beside either analog or digital ICU.
  width: 4000,
  height: 1100,
}

export const FALLBACK_COMPONENTS_BY_DETAIL = {
  JJ: 'Switch',
  A: 'Gauge',
  AC: 'Radio_CP001',
}

export default {
  ...DASH_META,
  ...META_BY_LOCATION_DETAIL,
  fallbacks: FALLBACK_COMPONENTS_BY_DETAIL,
  lists: {
    ICU: {
      id: 'ICU',
      label: 'A Panel: ICU',
      groups: {},
    },
    AUPNL: {
      id: 'AUPNL',
      label: 'B Panel: Right Hand Aux',
      groups: {
        AU800: {
          order: 0,
          id: 'AU800',
          panel: 'AUPNL',
          label: 'MSF 8',
          canDragGroup: true,
          isMsfOrMst: true,
          detail: ['JJ'],
        },
        AU700: {
          order: 1,
          id: 'AU700',
          panel: 'AUPNL',
          label: 'MSF 7',
          canDragGroup: true,
          isMsfOrMst: true,
          detail: ['JJ'],
        },
        AU600: {
          order: 2,
          id: 'AU600',
          panel: 'AUPNL',
          label: 'MSF 6',
          canDragGroup: true,
          isMsfOrMst: true,
          detail: ['JJ'],
        },
        AU500: {
          order: 3,
          id: 'AU500',
          panel: 'AUPNL',
          label: 'MSF 5',
          canDragGroup: true,
          isMsfOrMst: true,
          detail: ['JJ'],
        },
        AU400: {
          order: 4,
          id: 'AU400',
          panel: 'AUPNL',
          label: 'MSF 4',
          canDragGroup: true,
          isMsfOrMst: true,
          detail: ['JJ'],
        },
        AU300: {
          order: 5,
          id: 'AU300',
          panel: 'AUPNL',
          label: 'MSF 3',
          canDragGroup: true,
          isMsfOrMst: true,
          detail: ['JJ'],
        },
        au_gauges: {
          order: 6,
          id: 'gauges',
          panel: 'AUPNL',
          label: 'Aux Gauges',
          detail: ['A'],
        },
        au_other: {
          order: 7,
          id: 'other',
          panel: 'AUPNL',
          label: 'Aux Other',
          detail: [
            'E',
            'L',
            'D',
            'B',
            'H',
            'D-D',
            'S',
            'G',
            'T',
            'U',
            'A-A',
            'B-B',
          ],
        },
      },
    },
    AGPNL: {
      id: 'AGFAC',
      label: 'B Panel: Right Hand AG',
      groups: {
        LSMAN: {
          order: 0,
          id: 'LSMAN',
          panel: 'AGFAC',
          label: 'Left MSF',
          isMsfOrMst: true,
          detail: ['JJ'],
        },
        CSMST: {
          order: 1,
          id: 'CSMST',
          panel: 'AGFAC',
          label: 'Center MSF',
          isMsfOrMst: true,
          detail: ['JJ'],
          staticPart: {
            label: strings.hazard_lights,
            afterIndex: 4,
          },
        },
        RSMAN: {
          order: 2,
          id: 'RSMAN',
          panel: 'AGFAC',
          label: 'Right MSF',
          isMsfOrMst: true,
          detail: ['JJ'],
        },
        LPMN1: {
          order: 3,
          id: 'LPMN1',
          panel: 'AGFAC',
          label: 'Lower MSF 1',
          isMsfOrMst: true,
          detail: ['JJ'],
        },
        LPMN2: {
          order: 4,
          id: 'LPMN2',
          panel: 'AGFAC',
          label: 'Lower MSF 2',
          isMsfOrMst: true,
          detail: ['JJ'],
        },
        ag_gauges: {
          order: 5,
          id: 'gauges',
          panel: 'AGFAC',
          label: 'Gauges',
          detail: ['A'],
        },
        ag_other: {
          order: 6,
          id: 'other',
          panel: 'AGFAC',
          label: 'Other',
          detail: [
            'AC',
            'E',
            'L',
            'B',
            'H',
            'D-D',
            'S',
            'G',
            'T',
            'U',
            'A-A',
            'B-B',
            'PR',
            'JJ',
            'TB',
            'PR',
            'PB',
            'TA',
          ],
        },
      },
    },
  },
}
